import _, { isEmpty } from "lodash";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment-timezone";
import React, { Component } from "react";

import CardPrimary from "@/components/UI/Card/CardPrimary";
import { getQueryParams } from "@/utils/filters";
import images from "@/utils/images";
import ListHeader from "@/components/UI/ListView/ListHeader";
import { providerRequests } from "@/api/(requests)/provider";
import { providerRoute } from "@/config/roles";
import { scheduleRequests } from "@/api/(requests)/schedule";
import { sharedRequests } from "@/api/(requests)/shared";
import { showAlertWithAction } from "@/redux/actions/alerts";

import { createNewScheduledEvent, getExistingConflicts } from "./scheduleAvailabilityUtils";
import ScheduleEvent from "./ScheduleEvent";

class EditEvent extends Component {
  constructor(props) {
    super(props);
    let details = this.props.location.state ? this.props.location.state.details : {};
    let localDate = moment.utc(details.timestamp, "YYYY-MM-DD HH:mm").local();

    this.state = {
      datePickerConf: null,
      details: details,
      scheduleList: [],
      selectedDate: localDate,
      showDatePicker: false,
      time: localDate.format("HH:mm"),
    };
  }

  async componentDidMount() {
    let callId = getQueryParams("call_id", this.props.match.search);

    if (!callId) {
      this.props.showAlertWithAction("Invalid Request. Missing required field: callId.");

      return;
    }
    let data = {
      call_id: callId,
    };
    const tokenResponse = await sharedRequests.fetch_twilio_token({ data });
    const details = tokenResponse.call_details;
    const localDate = moment.utc(details.timestamp, "YYYY-MM-DD HH:mm").local();

    let startDate = moment.utc(details.timestamp, "YYYY-MM-DD  HH:mm");
    let endDate = _.cloneDeep(startDate).add(1, "days");
    let start_date = startDate.utc().format("YYYY-MM-DD");
    let end_date = endDate.utc().format("YYYY-MM-DD");
    const response = await scheduleRequests.get_schedule({
      searchParams: {
        end_date_time: end_date,
        provider_id: this.state.providerId,
        show_deleted: true,
        start_date_time: start_date,
      },
    });
    const scheduleList = response.schedule;
    const newDetails = scheduleList.find((schedule) => schedule.callId === callId);

    this.setState({
      details: newDetails,
      scheduleList,
      selectedDate: localDate,
      time: localDate.format("HH:mm"),
    });
  }

  setDatePickerConf = (type) => {
    this.setState((ps) => {
      return {
        datePickerConf: type,
        showDatePicker: !ps.showDatePicker,
      };
    });
  };

  dismiss = () => this.props.history.push(providerRoute + "/schedule");

  updateHandler = async (requestBody, type, patientId) => {
    const { timezone } = this.props;
    const { details } = this.state;

    if (!details || isEmpty(details)) {
      this.props.showAlertWithAction("Missing call details to update.");

      return;
    }
    const splittedTs = details.timestamp.split(" ");
    const data = {
      date: splittedTs[0],
      slot: splittedTs[1],
    };

    /** Delete and create schedule on the bases of Action type */
    if (type !== "away") {
      const searchParams = { callId: this.state.details.callId };
      const data = { rescheduled_as: requestBody.event_type };

      await sharedRequests.remove_appointment({ data, searchParams });
      await createNewScheduledEvent(type, requestBody, patientId, timezone);
    } else {
      await providerRequests.set_away_schedule({ data, searchParams: { method: "delete" } });
      await providerRequests.set_away_schedule({
        data: requestBody,
        searchParams: { method: "create" },
      });
    }
    this.dismiss();
  };

  setStartTimeSlot = (slotValue) => {
    this.setState({
      time: slotValue,
    });
  };

  render() {
    if (!this.state.details) {
      return <></>;
    }

    return (
      <div>
        <div className="survey-back-link-wpr mx-auto fs-16 my-3 py-2">
          <Link className="survey-back-link" to={providerRoute + "/schedule"}>
            <img className="img-fluid" src={images("./common/solidBckBtn.svg")} />
            <p className="d-inline ml-2">Back to Schedule</p>
          </Link>
        </div>
        <CardPrimary className="mx-auto" style={{ marginTop: 0 }}>
          <div>
            <ListHeader title="Edit Appointment" />
          </div>
          <hr className="d-none d-lg-block" />
          <div>
            {this.state.details && !isEmpty(this.state.details) && (
              <ScheduleEvent
                callDetails={this.state.details}
                datePickerConf={this.state.datePickerConf}
                dismiss={this.dismiss}
                edit
                eventType={this.state.details.event_type}
                existingConflicts={getExistingConflicts(
                  this.state.scheduleList.filter(
                    (event) => event.callId !== this.state.details.callId,
                  ),
                  this.state.selectedDate,
                )}
                getSpecificDateSchedule={this.getSpecificDateSchedule}
                onNewScheduleCreate={this.updateHandler}
                patientId={this.state.details.patient_username}
                selectedDate={this.state.selectedDate}
                selectedDateHandler={(date) => this.setState({ selectedDate: date })}
                seriesData={this.state.details.series_data}
                setDatePickerConf={this.setDatePickerConf}
                slot={this.state.details.timestamp}
                startTimeSlot={this.state.time}
                updateStartTimeSlot={this.setStartTimeSlot}
              />
            )}
          </div>
        </CardPrimary>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.auth.profile,
    timezone: state.auth.timezone,
  };
};

export default connect(mapStateToProps, { showAlertWithAction })(EditEvent);
